import {createRef, useContext, useState} from 'react';

import Input from '../../../base_components/Input';
import _axios from '../../../utils/axios';
import {handleError} from '../../../utils/utils';
import validate from '../../../utils/validator';
import Context from '../Context';

import buttonStyles from '../../../styles/base_components/Button.module.scss';
import styles from '../../../styles/cases/CreatingCase.module.scss';

function CreatingCase(props) {
  const inputRef = createRef();
  const [input, setInput] = useState('');
  const [inputError, setInputError] = useState('');
  const [inputWarning, setInputWarning] = useState('');

  const context = useContext(Context);

  function addCase(event) {
    if (inputError) return;
    const [inputErr] = validate([
      {value: input, type: 'caseName'}
    ]);
    if (inputErr) {
      setInputError(inputErr);
      return;
    }

    const data = {
      name: input,
      nodes: [],
      edges: []
    };
    _axios.post(context.role.CASES_PATH, data)
      .then(response => {
        const {ok, data} = response.data;
        if (typeof ok !== 'number' || typeof data !== 'object') throw new Error('The database does not correspond to our standard.');
        if (ok !== 1) throw new Error('The database is currently unavailable.');
        const {id, name, nodes, edges, created_at, updated_at} = data;
        console.log(data);  // TODO

        let err = validate([
          {value: id, type: 'db_case_id'},
          {value: name, type: 'db_case_name'},
          {value: nodes, type: 'db_case_nodes', empty: true},
          {value: edges, type: 'db_case_edges', empty: true},
          {value: created_at, type: 'db_case_created_at'},
          {value: updated_at, type: 'db_case_updated_at'}
        ]);
        err = err.filter(e => e !== '');
        if (err.length !== 0) throw new Error('Error at validating ' + data.name + ': ' + err.join('. '));

        setInput('');
        setInputError('');
        setInputWarning('');

        context.setCases(cases => [{id, name, nodes, edges, created_at, updated_at}, ...cases]);
      })
      .catch(handleError);
  }

  return (
    <div className={styles.creatingCase + ' ' + props.className}>
      <h2>Create a new case</h2>
      <Input
        className={styles.input}
        ref={inputRef}
        placeholder='Enter the name'
        value={input}
        setValue={setInput}
        error={inputError}
        setError={setInputError}
        warning={inputWarning}
      />

      <button className={buttonStyles.button + ' ' + styles.button} onClick={addCase}>add case</button>
    </div>
  );
}

export default CreatingCase;